export default __webpack_public_path__ + "static/media/Operations.992b4cf1.png";